/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import PreTreatmentFilledJournalEvent from "parog-web/models/pre-treatment-filled-journal-event";
import CtcaeCustomBaseEditionForm from "../base-edition-form/edition-form";

export default class PreTreatmentEditionForm extends CtcaeCustomBaseEditionForm {
  static forcDisplayName = "Questionnaire de pré-traitement";
  static fullComponentId = "pre-treatment/edition-form";

  static journalEventClass = PreTreatmentFilledJournalEvent;

  get currentSections(): Array<string> {
    return [
      ...this.temperatureSections,
      ...this.fatigueSections,
      ...this.coughSections,
      ...this.breathSections,
      "currentWeight",
      ...this.weightLossSections,
      "pacPainful",
      "pacInflammatory",
      "pacFlowing",
      "pacHealing",
      ...this.dermatologicalSections,
      ...this.nauseaVomitingSections,
      ...this.diarrheaSections,
      ...this.constipationSections,
      ...this.painSections,
      ...this.muscularPainSections,
      ...this.articularPainSections,
      ...this.otherPainSections,
      ...this.cortisoneSections,
      "radiotherapy"
    ];
  }
}
